import { z } from "zod";

import { defaultItem, defaultUrl, transformerMdContentParam, itemSchema, urlSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const experienceSchema = itemSchema.extend({
  company: z.string().min(1),
  position: z.string(),
  location: z.string(),
  date: z.string(),
  summary: transformerMdContentParam,
  url: urlSchema,
});

export const minimalExperienceSchema = experienceSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Experience = z.infer<typeof experienceSchema>;
export type MinimalExperience = z.infer<typeof minimalExperienceSchema>;

// Defaults
export const defaultExperience: Experience = {
  ...defaultItem,
  company: "",
  position: "",
  location: "",
  date: "",
  summary: "",
  url: defaultUrl,
};

export const deminimalizeExperience = (experience: MinimalExperience): Experience => {
  return {
    ...defaultExperience,
    ...experience,
    id: createId(),
  };
};
